import React from 'react'
import { makeStyles, createStyles, theme } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    main: {
      backgroundColor: '#f1f1f1',
      padding: '20px',
      float: 'left',
      textAlign: 'left',
      fontSize: '16px',
      fontFamily: 'Times New Roman',
      color: 'black',
      //   width: "60%",
    },
    heading: {
      textAlign: 'center',
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
      color: 'black',
    },
    text: { fontSize: '16px', fontFamily: 'Times New Roman', color: 'black' },
  }),
)

const FitterDisclaimerAndroid = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
          <Grid item xs={10} sm={8} md={8} lg={6}>
            <Paper className={classes.main}>
              <h1 className={classes.heading} style={{ fontSize: 33 }}>
                <b>Software End User Licence Agreement</b>
              </h1>
              <h2 className={classes.heading} style={{ fontSize: '23px' }}>
                <b> "RigV Fitter" ANDROID Version </b>
              </h2>
              <Typography className={classes.text}>
                Read the following terms and conditions carefully before
                downloading,installing or using this software (defined below).
                Filling in the space next to "I accept the terms in the License
                Agreement" indicates your acceptance of these terms and
                conditions. If you do not agree with such terms and
                conditions,click "Cancel".This Software is available only to
                individuals aged 13 years or older.if you are 13 or older but
                under the age of 18,you should review these terms and conditions
                with your parent or guardian to make sure that you and your
                parent or guardian understand these terms and conditions.
              </Typography>
              <br />
              <h2 className={classes.heading} style={{ fontSize: '23px' }}>
                LICENSE
              </h2>
              <Typography className={classes.text}>
                This End User License Agreement("License" or "License
                Agreement") is a legal agreement between Dolphin Logic System
                Private Limited("Dolphin") and you and applies to your use of
                this RigV software and all related documentation that
                accompanies this application("Software").
              </Typography>
              <br />
              <Typography className={classes.text}>
                Dolphin's licensors refers to any third parties licensing all or
                any portion such Software to Dolphin.This License is
                specifically intended for the benefit of Dolphin and any Dolphin
                licensors.
              </Typography>
              <br />
              <ol>
                <li>
                  Grant of License. SO long as you are in compliance with this
                  License Agreement,Dolphin grants a non-exclusive license to
                  use the Software subject to the restrictions set forth below.
                  No rights to the use of any Dolphin, or its
                  licensors,names,logos or trademarks are conveyed by this
                  License.This License Agreement is not for the sale of software
                  or any other intellectual property.All right,title and
                  interest, and all intellectual property.All right,title and
                  interest,and all intellectual property rights in and to the
                  Software is owned by Dolphin or its licensors. Except as
                  expressly stated herein, no other rights are granted to you by
                  implication,estoppel,or otherwise,under any
                  patent,copyright,trade secret,trademarks,or other intellectual
                  property right.
                </li>
                <br />
                <li>
                  Restrictions on Use. You may use the Software only on your
                  personal electronic device (e.g. computer,mobile phone,digital
                  camera,etc.).You may not further
                  redistribute,sublicense,rent,loan or lease the Software to a
                  third party.
                </li>
                <br />
                <li>
                  Copyright. The Software is owned by Dolphin,its licensors or
                  its suppliers and protected by copyright laws and
                  international treaties. You may not copy the Software other
                  than as expressly provided in this License. You may not
                  reverse engineer,decompile,disassemble or otherwise attempt to
                  derive the source code for the Software, or use any part of
                  the Software for any use other than that for which it was
                  supplied by Dolphin,unless specifically authorized by Dolphin.
                  You may not modify, adapt,alter,translate,or create derivative
                  works from the Software.
                </li>
                <br />
                <li>
                  Terms. This License is effective until terminated. You may
                  terminate this License at any time by deleting or otherwise
                  destroying the Software together with all copies in any form.
                  This License will also automatically terminate if you fail to
                  comply with any term or condition of this License. You agree
                  that Dolphin also may, at its sole descretion,temporarily or
                  permanently terminate the License with prior notice to you and
                  or terminate the Services as defined in paragraph,8) without
                  prior notice to you. Upon termination,for any reason,you agree
                  to destroy the Software together with all copies in any form.
                  Provisions which,by their nature,should remain in effect
                  beyond termination of this License Agreement shall survive.
                </li>
                <br />
                <li>
                  Compliance with Laws and Terms. you agree to comply with all
                  applicable laws in connection with the use of the Software and
                  Services. The form and content of pictures,text or other
                  material that you transmit or create products from is governed
                  by applicable laws ( such as, those prohibiting child abuse
                  child pornography, copyright infringement, or invasion of
                  privacy), if you use the Software to transmit material to
                  Dolphin, its affiliates , or any third party for printing or
                  product fulfillment or other purposes, you must comply with
                  the relevant terms of service. You may not use the Software to
                  transmit to Dolphin, its affiliates, or any third parties any
                  pictures,text or other material that is unlawful, whether a
                  violation of civil rights (such as libel) or criminal law
                  (such as obscenity), or that fosters hatred of any
                  race,religion,ethnicity,age-group,gender,indemnify and hold
                  Dolphin harmless against any claim arising out of or related
                  to your failure to comply with the terms of this Section5.
                </li>
                <br />
                <li>
                  Software Features. This Software may contain features that
                  enable Dolphin,via the internet, to notify you of available
                  software upgrades,promotions,products and services in which
                  you may be interested;to update product data files and
                  instructional and marketing content in the Software; and to
                  collect non-personally identifiable usage data.The Software
                  may also contain features that enable you to download store
                  locator files,new product themes and product catalogs. You
                  agree that Dolphin may utilize these features to provide such
                  notices and updates,permit such downloads and to collect such
                  data,unless you have elected to deactivate the features in the
                  Software.
                </li>
                <br />
                <li>
                  Privacy. The Software may request or collect certain limited
                  information about you when you use the Software.Such
                  information might consist of your name,your email address,the
                  names and email addresses of people that are stored on devices
                  that connect to the Software or that you send content and
                  information to through the Software, if you provide them, your
                  username and password for your email accounts and online
                  service providers(including, but not limited to
                  Dolphin,Facebook,Twitter,YouTube and Flickr) ("Login
                  Credentials") and device identification as well as technical
                  data and related information about your device, system and
                  application software (collectively "Personal Information").
                  The Software may also collect information regarding what
                  content you send through the Software and who you send it
                  to("Transmission Data"). The Software may also use cookies or
                  other passive tracking mechanisms and tools to collect
                  information in order to facilitate your use of the Software.
                  Any Login Credentials you provide to the Software will be
                  encrypted. Furthermore,Dolphin will collect aggregated
                  non-personal data from all users of the Software relating
                  to,for example,the number of images and videos transferred or
                  shared,the Services to which they were transferred,and the
                  number of individuals with whom images were shared ("Aggregate
                  Data"). Dolphin will only use the Aggregate Data to assess the
                  overall use of the Software by customers in order to determine
                  how the Software is being used and how it and other products
                  can be improved.
                  <br />
                  Please keep in mind that the nature of the Software and
                  services may be interactive,and as part of your use of
                  Software you will be provided the opportunity to share
                  information and content with third parties.You should use
                  caution when deciding what information and content to share
                  through the Software.
                  <br />
                  Dolphin may share Aggregate Data with vendors who assist
                  Dolphin in providing its products and services,with third
                  party business partners with whom Dolphin provides joint
                  promotions;with Dolphin's affiliated companies,including any
                  parent or subsidiaries of Dolphin; and Dolphin may share
                  Aggregate Data if Dolphin believes it is necessary to comply
                  with legal process (such as a court order,subpoena,search
                  warrant,etc.),or other legal requirements of any governmental
                  authority; if Dolphin believes it would potentially mitigate
                  Dolphin's believes it otherwise necessary to protect Dolphin's
                  rights or property; or is necessary to protect the interests
                  of other users of the Software.In the unlikely event that all
                  or part of Dolphin's business is sold or acquired by a third
                  party, Dolphin will transfer such information to the new
                  business owner.
                </li>
                <br />
                <li>
                  Third Party Services and Websites. As part of your use of the
                  Software, you may be provided with the opportunity to access
                  Dolphin's and third party services and web sites (collectively
                  and individually,"Services"). Use of the Services may require
                  internet access and that you accept additional terms of use.
                  You acknowledge and agree that while Dolphin and or such third
                  parties may not currently have set a fixed upper limit on the
                  number of transmissions you may send or receive through the
                  Service or the amount of storage space used for the provision
                  of the service, such fixed upper limits may be set by Dolphin
                  and or such third parties at any time, at Dolphin and or such
                  third parties' sole discretion.
                </li>
                <br />
                <li>
                  Your Representation and Warranties. You represent and warrant
                  that you possess the legal right and ability to agree to this
                  License Agreement, and that all information or material that
                  you transmit through the Software is owned by you. is
                  true,accurate and current, including Login Credentials. You
                  agree that you will not: (i) transit any material that is
                  copyrighted,protected by trade secret or otherwise subjected
                  to third party proprietary rights, including privacy and
                  publicity rights, unless you are the owner of such rights or
                  have written permission from their rightful owner to post the
                  materials and to grant the right to use such materials as
                  provided in this Agreement, (ii)submit any false information
                  or misrepresentation that could result in liability or damage
                  to us or any third party; (iii) submit any material that is
                  unlawful,obscene,defamatory,libelous,
                  <br />
                  threatening,pornographic,graphic or gratuitously
                  violent,harassing,hateful,racially or ethnically
                  offensive,encourages conduct that would give rise to criminal
                  or civil liability,violate any law,or is otherwise
                  inappropriate; (iv) impersonate another person, including
                  submitting their photographs as your own; (v) transmit
                  worms,viruses or other malicious codes; and (vi) violate the
                  terms and conditions of any website or application to which
                  you transmit Images through the Software.
                  <br />
                  You affirm that you are over the age of 13, and acknowledge
                  that the Software is not available for children under 13. If
                  you are under 13 years of age, then you may not use the
                  Software.
                </li>
                <br />
                <li>
                  DISCLAIMER OF WARRANTY. The Software is provided to you "AS
                  IS" Dolphin and its licensors do not warrant that the
                  functions contained in the Software will meet your
                  requirements or that the operation of the Software will be
                  uninterrupted or error free. You assume responsibility for
                  operation of the Software, and for the installation, use, and
                  results obtained from the Software.
                  <br />
                  The Software may contain hypertext links to third-party web
                  sites or information. Dolphin does not make any warranty,
                  endorsement, sponsorship, or recommendation of the
                  third-party, the third-party web site, or the information
                  contained therein. Dolphin is not responsible for the
                  availability of any such web site or liable for the content
                  thereon. You need to make your own decisions regarding your
                  interactions or communications with any other web site.
                  <br />
                  Subject to any applicable legislation which prohibits the
                  following exclusions, DOLPHIN AND ITS LICENSORS MAKE NO
                  WARRANTIES OF ANY KIND RELATED TO THE SOFTWARE, EITHER EXPRESS
                  OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF
                  MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE,
                  NON-INFRINGEMENT, or arising from course of performance,
                  dealing, usage or trade. Some states and countries do not
                  allow the exclusion of implied warranties, or have legislation
                  that imposes certain statutory warranties that cannot be
                  excluded, so the above exclusion may not apply to you.
                </li>
                <br />
                <li>
                  LIMITATION OF LIABILITY. Your use of the Software is entirely
                  at your own risk. Under no circumstance will Dolphin, its
                  agents, licensors or suppliers be liable to you on account of
                  your use or misuse of, or reliance on, the Software. TO THE
                  EXTENT PERMITTED BY LAW, IN NO EVENT WILL DOLPHIN, ITS
                  LICENSORS, SUPPLIERS OR DEALERS BE LIABLE TO YOU FOR ANY
                  ACTUAL, DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
                  OR PUNITIVE DAMAGES, INCLUDING ANY LOST PROFITS, LOST SAVINGS,
                  costs of procurement of substitute products or services OR
                  OTHER DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE
                  SOFTWARE EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                  Some states and countries do not allow the limitation or
                  exclusion of liability for incidental or consequential
                  damages, or have legislation that restricts the limitation or
                  exclusion of liability, so the above limitation may not apply
                  to you.
                </li>
                <br />
                <li>
                  The Software includes certain Application Programming
                  Interfaces ("API's") that are part of the Android software
                  platform and are governed by the terms and conditions of the
                  open source license, Apache 2.0 which can be found at
                  http://www.apache.org/licenses/LICENSE-2.0.html.
                </li>
                <br />
                <li>
                  Miscellaneous. Each provision of this License Agreement is
                  severable. If a provision is found to be unenforceable, this
                  finding does not affect the enforceability of the remaining
                  provisions, terms, or conditions of this License Agreement.
                  This License Agreement is binding on successors and assigns.
                  Dolphin will not be responsible for any non-performance or
                  delay attributable in whole or in part to any cause beyond its
                  reasonable control. Nothing contained herein shall be
                  construed as creating any agency, partnership, or other form
                  of joint enterprise between the parties. You acknowledge that
                  you have read this License Agreement, that you understand it,
                  that you agree to be bound by its terms, and that the
                  foregoing is the complete and exclusive statement of the
                  License Agreement.
                </li>
              </ol>
            </Paper>
          </Grid>
          <Grid item xs={1} sm={2} md={2} lg={3}>
            {/* <Paper className={classes.paper}>xs=3</Paper> */}
          </Grid>
        </Grid>
      </div>
    </>
  )
}
export default FitterDisclaimerAndroid
